<template>
  <p role="alert">
    <alert-icon />
    <slot></slot>
  </p>
</template>
